import { supabase } from "./supabase.js";
import { store } from "./store.js";

// A whitelist de Fundador/Backup Operator é aplicada pelo próprio projeto Supabase
// Auth (invite-only signup, configurado no E02 — ver memória de infra e
// docs/07-dashboard/PIXEL_DASHBOARD.md "Apenas emails whitelisted"). Este client só
// repassa a tentativa; um email fora da whitelist recebe erro do Supabase e nunca
// ganha sessão.
export async function requestMagicLink(email) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: window.location.origin },
  });
  if (error) throw error;
}

export async function signOut() {
  await supabase.auth.signOut();
  clearSessionStartedAt();
  store.session.set(null);
}

// Contorno para "sessão de até 30 dias" (PIXEL_DASHBOARD.md): o Supabase
// nativo ("Time-box user sessions") exige plano Pro (confirmado via
// Management API — ver design.md), e o projeto está no plano free por
// restrição de custo. Sem esse recurso do provedor, refresh tokens do
// Supabase não expiram sozinhos por tempo — então aplicamos o limite no
// client, guardando quando a sessão começou e forçando logout ao passar de
// 30 dias. Isso é uma política de higiene operacional, não um controle de
// segurança rígido (os 2 usuários já são contas confiáveis com acesso
// legítimo) — limitação assumida e documentada.
const SESSION_STARTED_AT_KEY = "dashboard_session_started_at";
const SESSION_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const SESSION_CHECK_INTERVAL_MS = 60 * 60 * 1000; // a cada hora, sessão pode ficar aberta dias numa aba

function recordSessionStartedAt() {
  if (!localStorage.getItem(SESSION_STARTED_AT_KEY)) {
    localStorage.setItem(SESSION_STARTED_AT_KEY, String(Date.now()));
  }
}

function clearSessionStartedAt() {
  localStorage.removeItem(SESSION_STARTED_AT_KEY);
}

async function enforceSessionMaxAge() {
  const startedAt = Number(localStorage.getItem(SESSION_STARTED_AT_KEY));
  if (!startedAt) return;
  if (Date.now() - startedAt > SESSION_MAX_AGE_MS) {
    await signOut();
  }
}

export async function initAuth() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  store.session.set(session);
  if (session) {
    recordSessionStartedAt();
    await enforceSessionMaxAge();
  }

  supabase.auth.onAuthStateChange((event, session) => {
    // SIGNED_IN é um novo login de verdade; TOKEN_REFRESHED (renovação
    // automática) não deve resetar o relógio dos 30 dias.
    if (event === "SIGNED_IN") recordSessionStartedAt();
    if (event === "SIGNED_OUT") clearSessionStartedAt();
    store.session.set(session);
  });

  setInterval(enforceSessionMaxAge, SESSION_CHECK_INTERVAL_MS);
}

export function isAuthenticated() {
  return store.session.get() !== null;
}
